import { useTranslations } from "next-intl";

import { useLayout } from "./context";

export function HeaderTitle() {
  const t = useTranslations("layout30.workspaceSelector");
  const { settings } = useLayout();
  const current = settings.identity?.workspace ?? t("current");

  return (
    <div
      data-slot="project-header-title"
      data-debug-source="components/layouts/layout-30/components/header-title.tsx"
      className="flex min-w-0 items-center"
    >
      <span
        className="block max-w-[min(18rem,45vw)] truncate px-2 text-sm font-semibold text-zinc-100"
        title={current}
      >
        {current}
      </span>
    </div>
  );
}
